export default "<ng-container >\r\n    <div class=\"modal-overlay\"></div>\r\n</ng-container>\r\n";